import { ReactNode } from "react";
import { Link, useNavigate } from "react-router-dom";
import { RoutingProvider } from "./RoutingProvider";
import { LinkProps } from "@amzn/xb-hooks";

export const ReactRouterProvider = ({ children }: { children: ReactNode }) => {
  const navigate = useNavigate();

  const tools = {
    Link: ({ children: linkChildren, path, replace, scrollToTopAfterNav }: LinkProps) => (
      <Link
        to={path}
        replace={replace}
        preventScrollReset={scrollToTopAfterNav !== undefined ? scrollToTopAfterNav : false}
      >
        {linkChildren}
      </Link>
    ),
    push: (url: string, scrollToTopAfterNav: boolean = false) =>
      navigate(url, {
        preventScrollReset: !scrollToTopAfterNav,
        replace: false,
      }),
    replace: (url: string, scrollToTopAfterNav: boolean) =>
      navigate(url, {
        preventScrollReset: !scrollToTopAfterNav,
        replace: true,
      }),
  };
  return <RoutingProvider {...tools}>{children}</RoutingProvider>;
};
